export default __webpack_public_path__ + "static/media/14.30866272.png";